import { Button, Stack, Typography } from '@mui/material';
import { CloseIcon } from 'assets';

interface PaymentFailedProps {
  onClose: () => void;
}

export const PaymentFailed = ({ onClose }: PaymentFailedProps) => {
  return (
    <Stack spacing={8}>
      <Stack spacing={1} alignItems={'center'}>
        <CloseIcon sx={{ color: '#FFA8A1', width: 60, height: 60 }} />
        <Typography variant="Web_Title_18" color={'primary.main'}>
          Payment Failed
        </Typography>
        <Typography fontSize={14} fontWeight={400} color={'text.secondary'}>
          Payment was unsuccessful
        </Typography>
      </Stack>
      <Button variant="contained" onClick={onClose}>
        Try Again
      </Button>
    </Stack>
  );
};

export default PaymentFailed;
